// Ícone SVG inline da bandeira Discover (sem requisição HTTP)
import * as React from 'react';

export function DiscoverIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Discover" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <path d="M0 22h48v6a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-6z" fill="#F58220" opacity=".15" />
      <text
        x="6"
        y="20"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="8"
        fill="#1A1A1A"
        letterSpacing="-0.2"
      >
        DISC
      </text>
      <circle cx="32" cy="17" r="4" fill="#F58220" />
      <text
        x="37"
        y="20"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="8"
        fill="#1A1A1A"
        letterSpacing="-0.2"
      >
        VER
      </text>
    </svg>
  );
}
